var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"publication-img"},[(_vm.imgsrc)?_c('q-img',{staticStyle:{"width":"160px","height":"250px"},attrs:{"src":_vm.imgsrc,"alt":_vm.imgalt,"no-default-spinner":"","transition":"slide-right"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }